<template>
  <BasicModal
    :title="'ミニロボ 設定'"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <!-- モーダル部 -->
    <ModalSelectMedia @updated='setIcon'/>
    <!-- URLコピー用 -->
    <input type="hidden" style="opacity: 0 !important;" id="copy_code_mini" :value="singleURL"/>
    <!-- main -->
    <div class="card-body" v-if="chatbot.chatbot_mini">
      <b-tabs style="padding: 16px; height: 75vh;" v-model="activeTabInfo" class="disp-scroll">
        <b-tab-item label="ミニロボリスト">
          <MiniSettingMain
            :chatbot="chatbot"
            :mediaCooperationItemMasterNameList="mediaCooperationItemMasterNameList"
            @updateChatBot="updateChatBot"
            @create-chatbot-mini="createChatBotMini"
            @update-chatbot-mini="updateChatBotMini"
            @delete-chatbot-mini="deleteChatBotMini"
            @copy-singlepage-url-mini="copySinglePageURLMini"
            @modal-active="modalActive"
            @delete-icon="deleteIcon"
            :isLoading="isLoading"
            :PCTRLLOG="CTRLLOG"
          />
        </b-tab-item>
        <b-tab-item label="共通変数一覧">
          <MiniSettingVar
            :chatbot="chatbot"
            :users="users"
            @create-chatbot-mini-variable-group="createChatBotMiniVariableGroup"
            @update-chatbot-mini-variable-group="updateChatBotMiniVariableGroup"
            @delete-chatbot-mini-variable-group="deleteChatBotMiniVariableGroup"
            @set-modal-footer-var="setModalFooterVar"
            :isLoading="isLoading"
            :PCTRLLOG="CTRLLOG"
          />
        </b-tab-item>
      </b-tabs>
      <!-- モーダル　日程調整者選択 -->
      <div style="position: fixed; top: 50vh; height: 50vh; width: 680px; background: #f0f0f0; z-index: 203;" v-if="modalFooterVar">
        <div class="disp-scroll" style="height: calc(50vh - 45px); padding: 16px; overflow-y: scroll;">
          <!-- タイトル (必須)参加者 -->
          <p style="text-align: left; font-weight: 600; display: flex;">
            <span class="mdi mdi-note-plus-outline -right-8px"></span>
            <span v-if="modalFooterVar.variable_user.is_AND">必須参加者 を選択</span>
            <span v-if="!modalFooterVar.variable_user.is_AND">参加者 を選択</span>
            <b-switch style="width: 100px; transform: translateY(2px); margin-left: auto;" size="is-small" v-model="modalFooterVar.variable_user.is_AND">切替</b-switch>
          </p>
          <p style="text-align: left; margin-top: 4px; margin-left: 4px; font-size: smaller; color: #666;"
            v-if="modalFooterVar.variable_user.is_AND">
            選択したメンバーは必ず参加します。<br/>
            シナリオ中の全日程調整に反映されます。
          </p>
          <p style="text-align: left; margin-top: 4px; margin-left: 4px; font-size: smaller; color: #666;"
            v-if="!modalFooterVar.variable_user.is_AND">
            選択した中から1人が選ばれ、選ばれた人が必ず参加します。<br/>
            シナリオ中の全日程調整に反映されます。
          </p>
          <div style="display: flex; flex-wrap: wrap; margin-top: 8px;">
            <SelectMemberTable
              :isCalendar="true"
              :users="users"
              :parameterHash="modalFooterVar.variable_user.users"
              :calParameter="{}"
              :selfUser="user"
              :calendarSettings="calendarSettings"
              :isSync="true"
              :isConfirm="false"
              :isSingelSelect="false"
              :usersStatusAPI="usersStatusAPI"
              @changeShowEventSelfSelectMember="addSelfUserHash"
              @createCalendarSettingsSelectMember="addUserHash"
              style="height: 250px;"/>
          </div>
          <!-- タイトル 任意参加者 -->
          <p style="text-align: left; font-weight: 600; margin-top: 12px;"><span class="mdi mdi-note-plus-outline -right-8px"></span>任意参加者 を選択</p>
          <p style="text-align: left; margin-top: 4px; margin-left: 4px; font-size: smaller; color: #666;">
            選択した中から1人が選ばれ、選ばれた人が参加できる場合は、参加します。<br/>
            シナリオ中の全日程調整に反映されます。
          </p>
          <div style="display: flex; flex-wrap: wrap; margin-top: 8px;">
            <SelectMemberTable
              :isCalendar="true"
              :users="users"
              :parameterHash="modalFooterVar.variable_user.users_sub"
              :calParameter="{}"
              :selfUser="user"
              :calendarSettings="calendarSettings"
              :isSync="true"
              :isConfirm="false"
              :isSingelSelect="false"
              :usersStatusAPI="usersStatusAPI"
              @changeShowEventSelfSelectMember="addSelfUserHashSub"
              @createCalendarSettingsSelectMember="addUserHashSub"
              style="height: 250px;"/>
          </div>
          <!-- タイトル 共有者 -->
          <p style="text-align: left; font-weight: 600; margin-top: 12px;"><span class="mdi mdi-note-plus-outline -right-8px"></span>共有者 を選択</p>
          <p style="text-align: left; margin-top: 4px; margin-left: 4px; font-size: smaller; color: #666;">
            選択されたメンバーは参加の可否にかかわらず、予定が共有されます。<br/>
            シナリオ中の全日程調整に反映されます。
          </p>
          <div style="display: flex; flex-wrap: wrap; margin-top: 8px;">
            <SelectMemberTable
              :isCalendar="true"
              :users="users"
              :parameterHash="modalFooterVar.variable_user.users_share"
              :calParameter="{}"
              :selfUser="user"
              :calendarSettings="calendarSettings"
              :isSync="true"
              :isConfirm="false"
              :isSingelSelect="false"
              :usersStatusAPI="usersStatusAPI"
              @changeShowEventSelfSelectMember="addSelfUserHashShare"
              @createCalendarSettingsSelectMember="addUserHashShare"
              style="height: 250px;"/>
          </div>
        </div>
        <div style="height: 45px; padding: 8px 16px;">
          <!-- 保存 -->
          <button style="height: 100%; width: calc(100% - 48px);" class="button is-small is-primary is-fullwidth" @click="updateChatBotMiniVariableGroup(modalFooterVar)">保存</button>
          <!-- 閉じる -->
          <button @click="modalFooterVar=null" class="button is-small" style="background: transparent; border: none; position: absolute; bottom: 8px; right: 8px;"><span class="mdi mdi-close mdi-24px"></span></button>
        </div>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">戻る</button>
    </div>
  </BasicModal>
</template>

<script>
import Tooltip          from '@/components/atoms/tooltips/Tooltip'
import BasicModal       from '@/components/Modals/BasicModal'
import ModalSelectMedia from '@/components/ui/ModalSelectMedia'
import MiniSettingMain  from '@/components/ChatBot/organisms/MiniSettingMain'
import MiniSettingVar   from '@/components/ChatBot/organisms/MiniSettingVar'
import SelectMemberTable from '@/components/molecules/tables/SelectMemberTable'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  components: {
    Tooltip,
    BasicModal,
    ModalSelectMedia,
    MiniSettingMain,
    MiniSettingVar,
    SelectMemberTable,
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true,
    },
    chatbot: {
      type: Object,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    calendarSettings: {
      type: Array,
      required: true
    },
    usersStatusAPI: {
      type: Array,
      required: true
    },
    /**
     * 媒体連携項目マスター一覧
     * @type {Array}
     */
    mediaCooperationItemMasterNameList: {
      type: Array,
      required: true,
    },
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      singleURL: null,
      activeTabInfo: 0,
      isMini: false,
      miniIdx: 0,
      modalFooterVar: null,
      isLoading: false
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    setModalFooterVar (url) {
      this.modalFooterVar = url
    },
    createChatBotMini (data) {
      let name = null
      if (data.name) {
        name = data.name
      } else {
        name = chatbot.name + Number(data.chatbot.chatbot_mini.length + 1)
      }
      let createChatBotMiniTemp = {
        name            : name,
        chatbot         : data.chatbot.bot_id,
        target_url      : null,
        start_url       : null,
        working_hours   : data.chatbot.working_hours,
        is_recruit      : false,
        is_permitted    : false,
        permit_users    : null,
        send_power      : 0,
        select_power    : 0,
        receive_power   : 0,
        subscribe_power : 0,
      }
      this.isLoading = true
      this.$store.dispatch('chatbot/createChatBotMini', createChatBotMiniTemp)
      .finally(()=>{
        this.isLoading = false
      })
    },
    updateChatBotMini (chatbotmini) {
      let updateChatBotMiniTemp = chatbotmini
      this.$store.dispatch('chatbot/updateChatBotMini', updateChatBotMiniTemp)
    },
    deleteChatBotMini (chatbotmini) {
      this.$store.dispatch('chatbot/deleteChatBotMini', chatbotmini.pk)
    },
    async createChatBotMiniVariableGroup (data) {
      if (!data.name) {
        alert('変数名が入力されておりません。入力をお願いいたします。\n（例）$name$')
      } else if (data.name[0] === "$" && data.name[data.name.length - 1] === "$") {
        this.isLoading = true
        let promises = []
        for (let mini of data.chatbot.chatbot_mini) {
          let createChatBotMiniVariableGroupTemp = {
            chatbotmini     : mini.pk,
            variable_name   : data.name,
            variable_data   : null,
            variable_user   : {
              is_AND: false,
              users: [],
              users_sub: [],
              users_share: [],
            },
            type            : data.varTypeInput,
          }
          let p = this.$store.dispatch('chatbot/createChatBotMiniVariableGroup', createChatBotMiniVariableGroupTemp)
          promises.push(p)
        }
        await Promise.all(promises)
        this.isLoading = false
        alert('作成しました')
      } else {
        alert('変数名が正しく入力されておりません。\n変数名の先頭と末尾に「$」を入力しているか確認をお願いいたします。')
      }
    },
    updateChatBotMiniVariableGroup (data) {
      let updateChatBotMiniVariableGroupTemp = data
      this.$store.dispatch('chatbot/updateChatBotMiniVariableGroup', updateChatBotMiniVariableGroupTemp)
      this.modalFooterVar = null
      alert('変更しました')
    },
    deleteChatBotMiniVariableGroup (pk) {
      this.$store.dispatch('chatbot/deleteChatBotMiniVariableGroup', pk)
    },
    searchMvar (mini) {
      if (this.searchMvarWord === '') {
        return mini
      } else {
        let obj = []
        for (const m of mini) {
          if (~m.name.toLowerCase().indexOf(this.searchMvarWord.toLowerCase())) obj.push(m)
        }
        return obj
      }
    },
    copySinglePageURLMini (data) {
      this.singleURL = process.env.OWN_ENDPOINT + '/single/' + data.chatbot.group + '/' + data.chatbot.bot_id + '/' + data.mini.pk
      this.$nextTick(() => {
        let codeToCopy = document.querySelector('#copy_code_mini')
        codeToCopy.setAttribute('type', 'text')
        codeToCopy.select()
        document.execCommand('copy')
        this.$buefy.snackbar.open({
          message: 'ロボ表示URLをコピーしました！',
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true
        })
        codeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      })
    },
    modalActive (data) {
      this.isMini  = data.isMini
      this.miniIdx = data.miniIdx
      this.$store.dispatch('mediapool/openSelectModal', {type:'image'})
    },
    setIcon (id) {
      // iconの更新
      this.$emit('setIcon', {
        chatbot: this.chatbot,
        id: id,
        miniIdx: this.miniIdx
      })
    },
    deleteIcon (index) {
      this.$emit('setIcon', {
        chatbot: this.chatbot,
        id     : null,
        miniIdx: index
      })
    },
    /** 参加者から自分の重複削除 */
    addSelfUserHash (userHash) {
      this.modalFooterVar.variable_user.users = this.$_.xor(this.modalFooterVar.variable_user.users, [userHash])
    },
    addSelfUserHashSub (userHash) {
      this.modalFooterVar.variable_user.users_sub = this.$_.xor(this.modalFooterVar.variable_user.users_sub, [userHash])
    },
    addSelfUserHashShare (userHash) {
      this.modalFooterVar.variable_user.users_share = this.$_.xor(this.modalFooterVar.variable_user.users_share, [userHash])
    },
    /** 参加者の重複削除 */
    addUserHash (data) {
      this.modalFooterVar.variable_user.users = this.$_.xor(this.modalFooterVar.variable_user.users, [data.user.user_hash])
    },
    addUserHashSub (data) {
      this.modalFooterVar.variable_user.users_sub = this.$_.xor(this.modalFooterVar.variable_user.users_sub, [data.user.user_hash])
    },
    addUserHashShare (data) {
      this.modalFooterVar.variable_user.users_share = this.$_.xor(this.modalFooterVar.variable_user.users_share, [data.user.user_hash])
    },
    updateChatBot (chatbot) {
      this.$emit('updateChatBot', chatbot)
    },
  }
}
</script>

<style lang="scss" scoped>
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChatBot/organisms/DetailMiniSetting.vue